import axios from '@axios'
export const state = {
  countries: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 0,
  totalRecords: 0,
}
export const getters = {
  allCountries: (state) => state.countries,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}
export const mutations = {
  GET_COUNTRIES: (state, data) => {
    state.countries = data.countries
    state.currentPage = data.page
    state.perPage = data.perPage
    state.totalPages = data.totalPages
    state.totalRecords = data.totalRecords
  },
  CREATE_COUNTRY: (state, country) => {
    state.countries.unshift(country)
  },
  UPDATE_COUNTRY: (state, country) => {
    state.countries = state.countries.filter(c => c.id !== country.id)
    state.countries.unshift(country)
  },
  REMOVE_COUNTRY: (state, country) => {
    state.countries = state.countries.filter(c => c.id !== country.id)

  },
}

export const actions = {
  async getCountries({ commit }, params = {}) {
    let { _commit } = params
    if (typeof (_commit) === 'boolean' && _commit === false) {
      return axios.get('/sms/countries', { params: params })
    }
    await axios.get('/sms/countries', { params: params }).then(resp => {
      if (resp.status === 200) {
        commit("GET_COUNTRIES", resp.data)
      }
    })
  },
  async getCountry({ commit }, country) {
    return axios.get(`/sms/country${country.id}`)
  },
  async createCountry({ commit }, country) {
    await axios.post('/sms/country', country)
      .then(response => {
        if (response.status === 201) {
          commit('CREATE_COUNTRY', response.data)
        }
      })
  },
  async updateCountry({ commit }, country) {
    await axios.put(`/sms/country/${country.id}`, country)
      .then(response => {
        if (response.status === 200) {
          commit('UPDATE_COUNTRY', response.data)
        }
      })
  },
  async removeCountry({ commit }, country) {
    await axios.delete(`/sms/country/${country.id}`)
      .then(response => {
        if (response.status === 204) {
          commit('REMOVE_COUNTRY', country)
        }
      })
  },
}
